import React, { useEffect, useRef, useState } from 'react'
import ChevronRight from '@material-ui/icons/ArrowForwardIosRounded'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { DrawerContent, DropdownIcon } from '../styled/styles'
import { Link } from 'gatsby'
import { useIntl } from 'react-intl'
import { useLocation } from '@reach/router'

function VerticalDrawer({ headline, headlinePath, children, id }) {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()
  const [currentLocation, setCurrentLocation] = useState(location.pathname)

  const drawerRef = useRef(null)
  const [openDrawer, setOpenDrawer] = useState(null)
  const intl = useIntl()

  const toggleDrawer = (event, drawerId) => {
    event.stopPropagation()
    setOpenDrawer(openDrawer === drawerId ? null : drawerId)
    setIsOpen(!isOpen)
  }

  const handleDrawerOpen = (e) => {
    e.stopPropagation()
    setIsOpen(false)
  }

  useEffect(() => {
    if (currentLocation !== location.pathname) {
      setIsOpen(false)
      setCurrentLocation(location.pathname)
    }
  }, [location.pathname])

  return (
    <div ref={drawerRef} className={clsx('h-auto'.isOpen ? 'mb-3' : 'mb-5')}>
      {headlinePath ? (
        <div
          className={clsx(
            'flex items-center justify-end cursor-pointer h-auto'
          )}
          onClick={(event) => toggleDrawer(event, id)}
        >
          <DropdownIcon active={isOpen}>
            <ChevronRight
              className={clsx(
                'w-4 h-4 ml-2 mr-0.5 transition duration-300 ease-in-out'
              )}
            />
          </DropdownIcon>
          <Link to={intl.formatMessage({ id: headlinePath })}>
            <div className="text-lg block leading-12 font-medium">
              {headline}
            </div>
          </Link>
        </div>
      ) : (
        <div
          className={clsx(
            'flex items-center justify-end cursor-pointer h-auto'
          )}
          onClick={(event) => toggleDrawer(event, id)}
        >
          {' '}
          <DropdownIcon active={isOpen}>
            <ChevronRight
              className={clsx(
                'w-4 h-4 ml-2 mr-0.5 transition duration-300 ease-in-out'
              )}
            />
          </DropdownIcon>
          <div className="text-lg block leading-12 font-medium">{headline}</div>
        </div>
      )}
      <DrawerContent isOpen={isOpen} onClick={(e) => handleDrawerOpen(e)}>
        {children}
      </DrawerContent>
    </div>
  )
}

VerticalDrawer.propTypes = {
  headline: PropTypes.string,
  headlinePath: PropTypes.string,
  children: PropTypes.any,
  id: PropTypes.string,
}

export default VerticalDrawer
